export default __webpack_public_path__ + "static/media/cgm.6007b3c9.png";